import { SelectAvatarLayer } from "./SelectAvatarLayer";
import { SplashScene } from "./SplashScene";
import { GameManager } from "./../../GameManager";
import { Button } from "../../utils/Utils";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class DificultySelectionLayer extends Phaser.GameObjects.Container {

    private casualButton: Button;
    private regularButton: Button;
    private expertButton: Button;
    private playButton: Button;
    private selectDifficultyText: Phaser.GameObjects.Text;

    private helpTick: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.visible = false;

        this.selectDifficultyText = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 250, GameVars.gameText.GAME[0], {fontFamily: "HelveticaNeue", fontSize: "45px", color: "#5E290E", align: "center"});
        this.selectDifficultyText.setOrigin(.5);
        this.add(this.selectDifficultyText);

        this.casualButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 250, 350, "texture_atlas_language", "btn_lvl_01", "btn_lvl_01_hover");
        this.casualButton.onDown(() => {this.onDifficultySelected(GameConstants.DIFFICULTY_CASUAL); }, this);
        this.add(this.casualButton);

        this.regularButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2, 350, "texture_atlas_language", "btn_lvl_02", "btn_lvl_02_hover");
        this.regularButton.onDown(() => {this.onDifficultySelected(GameConstants.DIFFICULTY_REGULAR); }, this);
        this.add(this.regularButton);

        this.expertButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 + 250, 350, "texture_atlas_language", "btn_lvl_03", "btn_lvl_03_hover");
        this.expertButton.onDown(() => {this.onDifficultySelected(GameConstants.DIFFICULTY_EXPERT); }, this);
        this.add(this.expertButton);

        let selectAvatarLayer = new SelectAvatarLayer(this.scene);
        this.add(selectAvatarLayer);

        this.helpTick = new Phaser.GameObjects.Image(this.scene, 100, 842, "texture_atlas_1", GameVars.gameData.showTutorial ? "tick_on" : "tick_off");
        this.helpTick.setOrigin(0, 1);
        this.helpTick.setInteractive();
        this.helpTick.on("pointerdown", this.onHelpDown, this);
        this.add(this.helpTick);

        let showHelpText = new Phaser.GameObjects.Text(this.scene, 180, 810, GameVars.gameText.GAME[2], {fontFamily: "HelveticaNeue", fontSize: "45px", color: "#5E290E", align: "center"});
        showHelpText.setOrigin(0, .5);
        this.add(showHelpText);

        let cancelButton = new Button(this.scene, 1000, 800, "texture_atlas_language", "btn_cancel", "btn_cancel_hover");
        cancelButton.setScale(.75);
        cancelButton.onDown(this.onCancelDown, this);
        this.add(cancelButton);

        this.playButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2, 350, "texture_atlas_1", "btn_play", "btn_play_hover");
        this.playButton.onDown(this.onPlayDown, this);
        this.add(this.playButton);

        this.casualButton.visible = false;
        this.regularButton.visible = false;
        this.expertButton.visible = false;
        this.selectDifficultyText.visible = false;
    }

    private onDifficultySelected(difficulty: string): void {

        AudioManager.playSound("click");

        GameVars.difficulty = difficulty;
        GameManager.enterBoardScene();
    }

    private onCancelDown(): void {

        AudioManager.playSound("click");
        
        SplashScene.currentInstance.showStartLayer();
    }

    private onPlayDown(): void {

        AudioManager.playSound("click");

        this.casualButton.visible = true;
        this.regularButton.visible = true;
        this.expertButton.visible = true;
        this.selectDifficultyText.visible = true;
        this.playButton.visible = false;
    }

    private onHelpDown(): void {

        AudioManager.playSound("click");

        GameVars.gameData.showTutorial = !GameVars.gameData.showTutorial;
        GameManager.writeGameData();

        this.helpTick.setFrame(GameVars.gameData.showTutorial ? "tick_on" : "tick_off");
    }
}
